<app-dashboard-stats-card [title]="'Open'" subtitle="Packages that are available." [count]="getPackageCount()"
                          [routerLink]="'/my-packages'" [queryParams]="{ open: true, open_o: 'is' }" />
